import React, { useState, useEffect } from "react";
import apiUrl from "../../v2/Constants/api";
import httpClass from "../../v2/components/shared/httpClass";

// import arrows from 'assets/img/list_news_images.png'
// import annualReportLink from 'assets/pdf/2017-annual-report.pdf';
const annualReportLink2019 = "https://www.worldvision.org.ph/wp-content/uploads/2020/07/WVDF-Annual-Report-2019.pdf";
const annualReportLink2020 = "https://www.worldvision.org.ph/wp-content/uploads/2021/03/WVDF-Annual-Report-2020.pdf";
const annualReportLink2022 = "https://www.worldvision.org.ph/wp-content/uploads/2023/08/Annual-Report-2022.pdf";
const annualReportLink2023 = "https://www.worldvision.org.ph/wp-content/uploads/2024/03/World-Vision-Annual-Report-2023.pdf";
const annualReportLink2024 = "https://www.worldvision.org.ph/wp-content/uploads/2025/02/2024_Annual-Report.pdf";
const url = apiUrl.urlV1;

// const styles = {
//   listStyle: 'none',
//   backgroundPositionX: '4px',
//   paddingLeft: '30px',
//   background: `url(${arrows}) no-repeat`
// }

const Feeds = props => {
    // console.log(props)
    // const feeds = highlights.map(function(feed, index) {
    //   return (
    //     <li style={styles} key={index}><a target="_blank" rel="noopener noreferrer" href={feed.node.path}>{feed.node.title}</a></li>
    //   )
    // })
    // const [aprLink, setAprLink] = useState("");
    const [aprLink, setAprLink] = useState("");

    useEffect(() => {
        getAprLink();
    }, []);

    function getAprLink() {
        const request = new httpClass(
            url +
                "/web/get-child-letters/apr-link?childId=" +
                props.childId +
                "&type=APR",
            "GET"
        );

        request.http().then(res => {
            if (res.result) {
                setAprLink(res.result);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    return (
        <div className="feeds">
            <h2 className="title_center">Organizational Reports</h2>
            {/* <ul className="news_of_the_month" style={{padding: '0'}}> */}
            {/* {feeds} */}
            <p>
                <a
                    href={annualReportLink2024}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    2024 Annual Report
                </a>
            </p>
            <p>
                <a
                    href={annualReportLink2023}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    2023 Annual Report
                </a>
            </p>
            <p>
                <a
                    href={annualReportLink2022}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    2022 Annual Report
                </a>
            </p>
            {/* <p>
                <a
                    href={annualReportLink2019}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    2019 Annual Report
                </a>
            </p>
            <p>
                <a
                    href={annualReportLink2020}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    2020 Annual Report
                </a>
            </p> */}
            {/* {aprLink && (
                <p>
                    <a
                        href={aprLink.url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Annual Progress Report
                    </a>
                </p>
            )} */}
            {/* </ul> */}
        </div>
    );
};

export default Feeds;
